import React from "react";

const Navigation = () => {
  //componente que renderiza el menu de navegacion en todas las paginas

  return (
    <>
      <nav id="menu" className="navbar navbar-default cont-nav-famedic">
        <div className="container nav-famedic">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
            >
              {" "}
              <span className="sr-only">Toggle navigation</span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
            </button>
            {/* <a className="navbar-brand page-scroll p-0 logo-desktop" href="/">
                <img
                  src="img/famedic-logo.png"
                  className="logo-img"
                  alt="Famedic IPS"
                />
              </a>{" "} */}
          </div>

          <div
            style={{ overflow: "hidden" }}
            className="collapse navbar-collapse nav-famedic-2"
            id="bs-example-navbar-collapse-1"
          >
            <div className="nav navbar-nav navbar-right nav-famedic">
              {" "}
              {/* este div nuevo */}
              <div className="nav-secondary">
                {/* <nav className="nav-secondary">
                  <ul className="navbar-secondary">
                    <li className="nav-social-icons">
                      <i className="fa fa-twitter"></i>
                      <i className="fa fa-facebook"></i>
                    </li>
                    <li>
                      <a style={{ fontSize: 14 * fontSizeMultiplier }} href="/">
                        PROGRAMAR CITA
                      </a>
                    </li>
                    <li>
                      <a style={{ fontSize: 14 * fontSizeMultiplier }} href="/">
                        TELEMEDICINA
                      </a>
                    </li>
                    <li>
                      <a style={{ fontSize: 14 * fontSizeMultiplier }} href="/">
                        PETICIONES
                      </a>
                    </li>
                    <li>
                      <a style={{ fontSize: 14 * fontSizeMultiplier }} href="/">
                        CONTÁCTANOS
                      </a>
                    </li>
                    <button
                      style={{ fontSize: 14 * fontSizeMultiplier }}
                      className="btn-dark-mode"
                    >
                      Modo oscuro
                    </button>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "5px",
                      }}
                    >
                      <button
                        onClick={() =>
                          changeFontSize(fontSizeMultiplier - 0.125)
                        }
                        style={{ border: "none" }}
                      >
                        -
                      </button>
                      <p
                        style={{
                          fontSize: 16 * fontSizeMultiplier,
                          color: "#fff",
                          margin: "auto 5px",
                        }}
                      >
                        Aa
                      </p>
                      <button
                        onClick={() =>
                          changeFontSize(fontSizeMultiplier + 0.125)
                        }
                        style={{ border: "none" }}
                      >
                        +
                      </button>
                    </div>
                  </ul>
                </nav> */}
              </div>
              <div className="nav-links-famedic">
                <a
                  className="navbar-brand page-scroll p-0 logo-desktop"
                  href="/"
                >
                  <img
                    src="img/famedic-logo.png"
                    className="logo-img"
                    alt="Famedic IPS"
                  />
                </a>{" "}
                <ul
                  className="nav navbar-nav nav-primary"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                  }}
                >
                  <li>
                    <a href="/#inicio" className="page-scroll">
                      Inicio
                    </a>
                  </li>
                  <li>
                    <a href="/servicios" className="page-scroll">
                      Servicios
                    </a>
                  </li>
                  <li>
                    <a href="/quienessomos" className="page-scroll">
                      ¿Quiénes somos?
                    </a>
                  </li>
                  <li>
                    <a href="/proveedores" className="page-scroll">
                      Proveedores
                    </a>
                  </li>
                  <li>
                    <a href="/#laboratorios" className="page-scroll">
                      Laboratorios
                    </a>
                  </li>
                  <li className="d-flex link-sedes">
                    {/* <img className="w-25" src="img/edificios.png" alt=" ICONO" /> */}
                    <a href="/sedes" className="page-scroll">
                      <img
                        className="w-25"
                        src="img/Iconos/SVG/Sedes.svg"
                        alt=" ICONO"
                      />
                      SEDES
                    </a>
                  </li>
                  <li>
                    <a href="/#nosotros" className="page-scroll">
                      INICIAR SESIÓN
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
